<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar
          v-model="formData"
          @search="handleSearch"
          @reset="handleReset"
          @getMainModel="getMainModel"
          ref="search"
        ></search-bar>
      </el-header>
    </el-container>
    <div class="main">
      <div class="header">
        <div>
          <el-link
            style="
              position: relative;
              top: -2px;
              left: 15px;
              font-weight: normal;
            "
            type="info"
            :underline="false"
            @click="returnToPrevious"
            v-if="showLink"
            >< 返回上次搜索结果</el-link
          >
        </div>
        <div class="tiite-header">
          <span>型号：{{  formDataTwo.smallModel || formDataTwo.bigModel || bigModel}}</span>
        </div>
        <div class="title">
          <div
            :class="`serach-title ${
              borderOne == 1 ? 'borderShow' : 'borderNone'
            }`"
            style="border-top-left-radius: 8px"
            @click="buttomType(1)"
          >
            当前店铺
          </div>
          <div
            :class="`serach-titleTwo ${
              boderTwo == 1 ? 'borderShow' : 'borderNone'
            }`"
            style="border-top-right-radius: 8px"
            @click="buttomType(2)"
          >
            全网推荐
          </div>
        </div>
        <div class="title-box">
          <div class="left" v-loading="loading">
            <div
              style="width: 50%; height: 100%"
              ref="distribute"
            ></div>
            <div
              :style="`${resolvingPower != 1920 ? 'width: 220px;' : 'width: 280px' }height: 100%;display: flex;align-items: center;padding-right: 0px;`"
            >
              <el-table
                border=""
                :data="proportionTableData"
                :cell-style="rowClassClick"
                height="calc(80% - 10px)"
              >
                <el-table-column prop="rownum" :width="`${resolvingPower != 1920 ? '50px' : '100px'}`" label="排名"></el-table-column>
                <el-table-column prop="categoryName" :width="`${resolvingPower != 1920 ? '80px' : '100px'}`" label="类别名称">
                  <template slot-scope="scope">
                    <span class="categoryCilck"
                      @click="getBigModelSalesTop(scope.row,scope.$index)"
                      >{{ scope.row.categoryName }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column prop="ratio" :width="`${resolvingPower != 1920 ? '80px' : '100px'}`" label="当前店铺">
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div class="right">
            <div class="text-header">
              <strong style="width: 30%">{{salesTopRwo.categoryName ? salesTopRwo.categoryName : "相关产品"}} top10排名</strong>
              <el-form
                :model="form"
                size="small"
                :inline="true"
                style="text-align: right; width: 100%"
              >
                <span class="form-number-input">
                  <el-form-item label="日常活动到手价：">
                    <el-input
                      v-model="before"
                      :controls="false"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="~" class="date-number-middle">
                    <el-input
                      v-model="after"
                      :controls="false"
                    ></el-input>
                  </el-form-item>
                </span>
                <el-form-item>
                  <el-button type="primary" @click="onSearch">搜索</el-button>
                  <el-button class="orange-btn" @click="onReset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
            <div class="canvas-box" v-loading="loading2">
              <div ref="overview" :style="`width: 50%; height: 100%`"></div>
              <div style="width: 50%; height: 100%">
                <el-table
                  :data="modelSalesTopListTwo"
                  :header-cell-style="{
                    backgroundColor: '#FAFAFA',
                  }"
                  :row-style="{ height: '1.9vw' }"
                  :cell-style="rowClass"
                  height="calc(100% - 25px)"
                  style="width: 100%"
                >
                  <el-table-column
                    prop="bigModel"
                    label="型号"
                    align="center"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    align="center"
                    prop="storeSaleNum"
                    label="当前店铺"
                  ></el-table-column>
                  <el-table-column prop="price" align="center" show-overflow-tooltip min-width="120" label="日常活动到手价">
                  </el-table-column>
                  <el-table-column prop="type" align="center" label="属性" min-width="60">
                    <template slot-scope="scope">
                      <el-link
                        :underline="false"
                        type="primary"
                        @click="showDialog(scope.row, 0)"
                        >查看</el-link
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div class="text-header">
          <strong style="font-size:17px">主推类型总览</strong>
        </div>
        <div style="padding-left: 25px; height: calc(100% - 30px)">
          <el-table
              border
              v-loading="loading1"
              :data="modelData"
              height="calc(100% - 20px)"
              style="width: calc(100% - 30px)"
            >
              <el-table-column v-for="item  in modelColumn" :key="item.prop" align="center" :prop="item.prop" :label="item.lable">
                <template slot-scope="scope">
                  <el-link
                    :underline="false"
                    @click="showOverviewDialog(scope.row[scope.column.property],item.lable)"
                    >{{ scope.row[item.prop] }}</el-link
                  >
                </template>
              </el-table-column>
            </el-table>
        </div>
      </div>
    </div>
    <!-- 查看弹框 -->
    <property-view
      v-model="recordDialogVisible"
      @dialog="dialog"
      :type="dialogType"
      v-if="recordDialogVisible"
    ></property-view>
    <overview-dialog
      v-model="overviewDialogVisible"
      @overviewDialog="overviewDialog"
      :overviewData="overviewData"
      :type="dialogType"
      v-if="overviewDialogVisible"
    ></overview-dialog>
  </div>
</template>

<script>
import searchBar from "./search";
import pie from "./pie/pie.mixin";
import bar from "./bar/bar.mixin";
import pagePathMixin from '@/utils/page-path-mixin'
import { mapState } from "vuex";
import propertyView from "./propertyView.vue";
import overviewDialog from "./overviewDialog.vue";
import moment from "moment";
export default {
  name: "ModelQuery",
  mixins: [pie, bar, pagePathMixin],
  components: {
    searchBar,
    propertyView,
    overviewDialog
  },
  data() {
    return {
      tableHeight: 0,
      loading: false,
      loading1: false,
      loading2: false,
      formData: {},
      tableData: [],
      paginationOpt: {
        pageSizes: [30, 60, 90],
        pageSize: 30,
        pageNum: 1,
        total: 0,
      },
      borderOne: 0,
      borderOneOld: 0,
      boderTwo: 1,
      form: {},
      recordDialogVisible: false,
      modelData: [],
      proportionTableData: [],
      tableDataTopTen: [],
      modelSalesTopList: [],
      modelSalesTopListTwo: [],
      modelSalesTopThere: [],
      after: '',
      before: '',
      LastData: [],
      showLink: false,
      collocationCategory: '',
      overviewData: [],
      overviewDialogVisible: false,
      salesTopRwo: {},
      formDataTwo: {},
      colorIndex: 0,
      modelColumn: [],
      dialogType: 3,
    };
  },
  watch: {
    formDataTwo: {
      handler(val,old) {
      if (this.borderOneOld == 0) {
        old.chartStoreCode = old.storeCode;
      } else {
        old.chartStoreCode = "";
      }
      if(!old.bigModel) {
        this.$store.commit("sreachData/addData", val)
      }else {
        this.$store.commit("sreachData/addData", old)
      }
      }
      
    },
    borderOne: {
      handler(val,old) {
        this.borderOneOld = old || 0
      }
      
    },
  },
  computed: {
    bigModel() {
      return this.$route.query.bigModel;
    },
    columnData() {
      let data = [
        {prop:'bed',lable:'床'},
        {prop:'sofa',lable:'沙发'},
        {prop:'wardrobe',lable:'衣柜'},
        {prop:'diningTable',lable:'餐桌'},
        {prop:'teaElectricityComb',lable:'茶电组合'},
        {prop:'leisure',lable:'休闲'},
        {prop:'other',lable:'其他'},
      ]
      return data
    },
    resolvingPower() {
      return document.body.clientWidth
    },
    ...mapState({
      sreachData: (state) => state.sreachData.formData,
    }),
    // sreachData() {
    //   return this.$store.state.sreachData.tableData;
    // },
  },
  mounted() {
  },
  methods: {
    handleSearch(data) {
      this.formData = data;
      this.formDataTwo = JSON.parse(JSON.stringify(data));
      if (this.borderOne == 0) {
        this.formData.chartStoreCode = this.formData.storeCode;
      } else {
        this.formData.chartStoreCode = "";
      }
      // this.formDataTwo = JSON.parse(JSON.stringify(this.formData));
      this.init();
      this.showLink = true
    },
    handleReset() {
      this.proportionTableData = []
      this.modelSalesTopListTwo = []
      this.render_right([]);
      this.render_left([]);
    },
    onReset() {
      this.after = ''
      this.before = ''
      this.getBigModelSalesTop(this.salesTopRwo,this.columnIndex)
    },
    onSearch() {
      this.loading2 = true;
      let data = {
        after:this.after,
        before:this.before,
        voList:[...this.modelSalesTopList]
      }
      this.$q.intelligentRecom
        .getPriceScreening({ data: data})
        .then((res) => {
          if(res.data.length) {
            this.modelSalesTopThere = res.data
            this.modelSalesTopListTwo = JSON.parse(JSON.stringify(this.modelSalesTopThere)).slice(0,10)
            this.render_left(this.modelSalesTopListTwo,this.resolvingPower);
          }else {
            this.modelSalesTopListTwo = []
            this.render_left([]);
          }
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
    init() {
      this.loading = true;
      this.$q.intelligentRecom
        .getClassificationRatio({ data: this.formData })
        .then((res) => {
          if(res.code == 200 && res.data.length) {
            this.proportionTableData = res.data
            this.render_right(this.proportionTableData,this.resolvingPower);
            this.getBigModelSalesTop(this.salesTopRwo.categoryName ? this.salesTopRwo :this.proportionTableData[0])
          }else {
            this.proportionTableData = []
            this.render_right(this.proportionTableData);
            this.modelSalesTopListTwo = []
            this.render_left(this.modelSalesTopListTwo);
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    returnToPrevious() {
      this.formData = this.sreachData
      this.formDataTwo = this.sreachData
      if(this.formData.chartStoreCode) {
        this.borderOne = 0
        this.boderTwo = 1
      }else {
        this.boderTwo = 0
        this.borderOne = 1
      }
      this.init()
    },

    getBigModelSalesTop(row,index) {
      this.after = ''
      this.before = ''
      this.colorIndex = index || 0
      this.salesTopRwo = row
      this.loading2 = true;
      this.collocationCategory = row.categoryName
      let data = {
        ...this.formData,
        collocationCategory: row.categoryName,
      };
      this.$q.intelligentRecom
        .getBigModelSalesTop({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.modelSalesTopList = res.data
            this.modelSalesTopListTwo = JSON.parse(JSON.stringify(this.modelSalesTopList)).slice(0,10)
            this.render_left(this.modelSalesTopListTwo,this.resolvingPower);
          } 
        })
        .finally((_) => {
          this.loading2 = false;
        });
    },
    showOverviewDialog(bigModel,lable) {  
      this.dialogType = 2
      let data = {
        bigModel: bigModel,
        categoryName: lable,
        storeCode: this.$refs["search"].form.storeCode

      }
      this.$q.intelligentRecom
        .bigModelBaseData({data:data})
        .then((res) => {
          if (res.data && res.code == 200) {
            console.log(res.data);
            this.overviewData = res.data;
            this.overviewDialogVisible = true;
          } else {
            // this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    overviewDialog(type) {
      this.overviewDialogVisible = type;
    },
    getMainModel(data) {
      this.loading1 = true;
      this.modelColumn = []
      let params = {
        params:{
          storeCode: data || ""
        }
      }
      this.$q.intelligentRecom
        .getMainModels(params)
        .then((res) => {
          if (res.data && res.code == 200) {
            let data = res.data.keyAndVal
            Object.keys(data).forEach(key=>{
              this.modelColumn.push({
                lable: data[key],
                prop: [key][0]
              })
            })
            this.modelData = res.data.dataList
          } else {
            this.modelData = [];
          }
        })
        .finally((_) => {
          this.loading1 = false;
        });
    },

    showDialog(row) {
      this.dialogType = 1
      this.see(row.bigModel)
    },
    //产品基础属性查看 搜索
    see(bigModel) {
      let data = {
        choiceBigModel: bigModel,
        collocationCategory: this.collocationCategory,
        ...this.formData
      }
      this.$q.intelligentRecom
        .getProductBasisInfo({data:data})
        .then((res) => {
          if (res.data && res.code == 200) {
            this.overviewData = res.data;
            this.overviewDialogVisible = true;
          } else {
            // this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },

    dialog(type) {
      this.recordDialogVisible = type;
    },
    buttomType(index) {
      if (index == 1) {
        this.formData.chartStoreCode = this.formData.storeCode;
        this.borderOne = 0;
        this.boderTwo = 1;
      } else {
        this.formData.chartStoreCode = "";
        this.boderTwo = 0;
        this.borderOne = 1;
      }
      this.init()
    },
    rowClass(data) {
      if (data.column.label == "当前店铺") {
        return "color: #4BBFE2;";
      } else if (data.column.label == "日常活动到手价") {
        return "color: #FF8A02;";
      }
    },
    rowClassClick({row, column, rowIndex, columnIndex}) {
        if( column.label == "类别名称") {
         if (rowIndex == this.colorIndex) {
          return "color: #0BB78E !important";
        }
      }
     
    },
  },
  beforeDestroy() {
    this.$store.commit("sreachData/delData");
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 10px 5px 10px 5px;
  width: auto;
  height: calc(100% - 25px);
  box-sizing: border-box;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.main {
  height: calc(100% - 60px);
  // padding: 5px 8px;
  // background: #ffffff;
  border-radius: 5px;
  position: relative;
}

.tiite-header {
  position: absolute;
  top: 20px;
  left: 45%;
  font-size: 24px;
  font-weight: 700;
  color: #0BB78E;
}

.header {
  height: calc(70% - 14px);
  padding: 10px;
  background: #ffffff;
  border-radius: 5px;
}

.footer {
  height: calc(30% - 14px);
  padding: 10px;
  margin-top: 5px;
  background: #ffffff;
  border-radius: 5px;
}

.left {
  width: 40%;
  height: 100%;
  border: 1px #e4e7ed solid;
  border-radius: 8px;
  display: flex;
  flex-wrap: nowrap;
}

.right {
  height: 100%;
  margin-left: 10px;
  width: calc(60% - 10px);
  border: 1px #e4e7ed solid;
  border-radius: 8px;
  padding-left: 5px;
}

.title {
  width: 160px;
  display: flex;
  flex-wrap: nowrap;
  margin-top: 10px;
  position: relative;
  background: #ffffff;
  top: 1px;
}

.serach-titleTwo {
  z-index: 5;
  cursor: pointer;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #606266;
  border-top: 1px #e4e7ed solid;
  border-right: 1px #e4e7ed solid;
}

.serach-title {
  z-index: 5;
  cursor: pointer;
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #606266;
  border-top: 1px #e4e7ed solid;
  border-left: 1px #e4e7ed solid;
  border-right: 1px #e4e7ed solid;
}

.serach-title:hover {
  color: #0BB78E;
  transition: all 0.3s;
}

.serach-titleTwo:hover {
  color: #0BB78E;
  transition: all 0.3s;
}

.title-box {
  // width: 100%
  height: calc(100% - 80px);
  padding: 10px;
  border: 1px #e4e7ed solid;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  display: flex;
  flex-wrap: nowrap;
}

.borderShow {
  border-bottom: 1px #e4e7ed solid;
  color: #606266;
  font-size: 14px;
  font-weight: 500;
}

.borderNone {
  color: #0BB78E;
}

.canvas-box {
  display: flex;
  padding-right: 25px;
  height: calc(100% - 40px);
}

>>> .canvas-box .el-table th {
  background: #fff !important;
  color: #000;
}

.text-header {
  font-size: 17px;
  color: #444;
  padding: 10px 1.3vw 10px 1.3vw;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
}

>>> .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
  margin-bottom: 0;
}

>>> .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
}

>>> .text-header .el-form .el-input {
  width: 80px;
}

>>> ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.canvas-box /deep/.el-table {
  border: 0;

  th, tr, td {
    border: 0;
    background-color: #fff;
  }

  &::before {
    height: 0px;
  }

  &::after {
    width: 0;
  }

  .el-table__fixed:before {
    height: 0;
  }
}

>>> .form-number-input .date-number-middle .el-form-item__label {
  width: 20px !important;
}

.categoryCilck{
  &:hover{
       color: #0BB78E;
       cursor: pointer
    }
}
</style>